<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center" v-if="loginFailed">
        <b-col md="8">
          <b-alert show variant="danger">
            Login failed. Please try again.
          </b-alert>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form v-on:submit.prevent="login()">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend
                      ><b-input-group-text
                        ><i class="icon-user"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Username"
                      v-model="user.email"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend
                      ><b-input-group-text
                        ><i class="icon-lock"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      placeholder="Password"
                      v-model="user.password"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button
                        variant="primary"
                        class="px-4"
                        type="button"
                        @click="login()"
                        >Login</b-button
                      >
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0"
                        >Forgot password?</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card
              no-body
              class="text-white bg-holly py-5 d-md-down-none"
              style="width:44%"
            >
              <b-card-body class="text-center">
                <div>
                  <img
                    src="img/logo.png"
                    style="width: 100%;margin-top: 10px;"
                    alt=""
                  />
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "login",
  data() {
    return {
      user: {},
      loginFailed: false
    };
  },
  methods: {
    login: function() {
      let scope = this;
      axios
        .post(process.env.VUE_APP_API + "/user/login", scope.user)
        .then(function(response) {
          scope.$localStorage.set("holly-fi-token", response.data.token);
          let user = {
            id: response.data.user._id,
            macAddress: response.data.user.macAddress,
            isSuperAdmin: response.data.user.isSuperAdmin,
            isAdmin: response.data.user.isAdmin,
            company: response.data.user.company,
            email: response.data.user.email,
            companyName: response.data.companyName
          };
          scope.$localStorage.set("holly-fi-user", JSON.stringify(user));
          scope.$router.push("/dashboard");
        })
        .catch(function(error) {
          scope.loginFailed = true;
          console.log(error);
        });
    }
  }
};
</script>
